import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ClickIt, DismissAlertTitle } from "../../../Constants/Constants";
import { DismissAlertSubTitle } from "../../../Data/BonusUi/SweetAlert";

const DismissAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "Oops...",
      text: "Something went wrong!",
      icon: "error",
      footer: '<a href="#">Why do I have this issue?</a>'
    });
  };
  return (
    <Col xxl="3" xl="4" sm="6" xs="12" className="box-col-4">
      <Card className="height-equal">
        <CommonCardHeader title={DismissAlertTitle} span={DismissAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="success" className="m-0" onClick={handleAlert}>
            {ClickIt}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DismissAlert;
